<template>
    <div v-if="message" data-testid-alert class="alert">
        {{ message }}
    </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
    name: "NotificationAlert",
    props: {
        message: String,
    },
});
</script>

<style lang="scss" scoped>
@import "@/styles/colors.scss";

.alert {
    color: $slks-error;
    font-size: 0.875rem;
}
</style>
